import { createFieldSelectorHook } from 'src/lib/sweetState';

import { OnboardingStore } from './Store';

export const useOnboardingCurrentStepId = createFieldSelectorHook(OnboardingStore, 'currentStepId');
